export default "__VITE_ASSET__DmGDXI5Z__"